export default "__VITE_ASSET__DHPdUkS$__"